export default {
    Aruba: "Aruba",
    Bolivia: "Bolivie",
    Brazil: "Brésil",
    Colombia: "Colombie",
    "Dominican Republic": "République dominicaine",
    Ecuador: "Equateur",
    England: "Angleterre",
    "French Guiana": "Guyane Française",
    Mexico: "Mexique",
    Nicaragua: "Nicaragua",
    Panama: "Panama",
    Paraguay: "Paraguay",
    "Puerto Rico": "Porto Rico",
    "Saint Martin": "Saint Martin",
    "Trinidad and Tobago": "Trinité-et-Tobago",
    "United States": "États-Unis",
    Uruguay: "Uruguay",
    Venezuela: "Venezuela"
}
